module.exports = __webpack_public_path__ + "static/media/instacollect.f258af9e.svg";